import displayName from "../tools/display-name";

const makeEmptyUser = () => ({
    id: '',
    name: '',
    surname: null,
    patronymic: null,
    roles: [],
    user_email: '',
    tokenFromGetParams: null,
});

export default {
    namespaced: true,
    state: {
        user: makeEmptyUser(),
        hasAccess: false,
        isAuthReady: false,
        isImpersonated: false,
    },
    mutations: {
        setIsImpersonated: (state, value) => {
            state.isImpersonated = value;
        },
        setAuthReady: (state) => {
            state.isAuthReady = true;
        },
        setHasAccess: (state, v) => {
            state.hasAccess = v;
        },
        setUser: (state, user) => {
            let profile = user ? user.profile : makeEmptyUser();
            if (profile) {
                state.user.id = profile.user_id;
                state.user.name = profile.user_name;
                state.user.surname = profile.user_surname;
                state.user.patronymic = profile.user_patronymic;
                state.user.roles = Array.isArray(profile.roles) ? profile.roles : [profile.roles];
            }
        },
    },
    actions: {
        registerSecurityService: async (ctx, securityService) => {
            securityService.addUserListener((user) => {
                const token = user ? user.access_token : '';
                let isImpersonated = false;
                if (token) {
                    const base64Url = token.split('.')[1];
                    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(''));
                    const tokenData = JSON.parse(jsonPayload);
                    isImpersonated = tokenData.impersonated === 'True';
                }
                ctx.commit('setIsImpersonated', isImpersonated);
                ctx.commit('setUser', user);
                ctx.commit('setAuthReady');
                ctx.commit('setHasAccess', true);
            });
        },
    },
    getters: {
        user: state => state.user,
        userId: (state, getters) => getters.isAuthorized ? state.user.id : null,
        isImpersonated: (state) => state.isImpersonated,
        userDisplayName: (state, getters, rootState, rootGetters) => {
            if (!getters.isAuthorized) {
                return null;
            }
            return rootGetters.userProfileName
                || displayName([state.user.name, state.user.surname]);
        },
        getUserRoles: state => state.user && state.user.roles ? state.user.roles : [],
        isAuthorized: state => state.user && !!state.user.id,
        userHasRoles: (state, getters) => roles => roles.filter(role => getters.getUserRoles.includes(role)).length > 0,
        userHasAccess: state => state.hasAccess,
        isAuthReady: state => state.isAuthReady,
        userAvatarUrl:  (state, getters, rootState, rootGetters) => rootGetters.userAvatarUrl || null,
        userHasRoleAttribute: (state, getters, rootState) => {
            const roleAttributes = getters.getUserRoles
                .reduce((acc, role) => {
                    return {
                        ...acc,
                        ...(rootState.roleAttributes.roleAttributes[role] || {}),
                    };
                }, {});
            return (key) => {
                return roleAttributes[key] !== undefined;
            };
        },

        hasAdminAccess: (state, getters) => getters.userHasRoles([
            'ROLE_ADMIN',
            'ROLE_USER_ADMIN_READ_ONLY',
            'ROLE_USER_ADMIN_READ_ONLY_NO_CONTACTS',
        ]),
        hasUserSearchAccess: (state, getters) => getters.userHasRoles([
            'ROLE_ADMIN',
            'ROLE_USER_ADMIN_READ_ONLY',
            'ROLE_USER_ADMIN_READ_ONLY_NO_CONTACTS',
        ]),
        hasUserContactsAccess: (state, getters) => getters.userHasRoles([
            'ROLE_ADMIN',
            'ROLE_USER_ADMIN_READ_ONLY',
        ]),
    },
};
